



























import { Prop, Component, Vue } from 'vue-property-decorator';
import { IMatrix, colors } from '@/misc';

@Component({})
export default class SvgGraph extends Vue {
  public colors = colors;

  @Prop() protected matrix!: IMatrix;

  protected get ix() { return this.matrix.ix; }
  protected get iy() { return this.matrix.iy; }
  protected get jx() { return this.matrix.jx; }
  protected get jy() { return this.matrix.jy; }
  protected get tx() { return this.matrix.tx; }
  protected get ty() { return this.matrix.ty; }
}
